import { render, staticRenderFns } from "./IconAngle.vue?vue&type=template&id=29256eba&scoped=true"
import script from "./IconAngle.vue?vue&type=script&lang=js"
export * from "./IconAngle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29256eba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBase: require('/app/components/anyvan/IconBase.vue').default})
